import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { useGlobalState } from 'src/sites/state'

const Titlebar = ({
   borderStyle,
   children,
   paddingLeft,
   paddingRight,
   size
}) => {
   const { theme } = useGlobalState()
   const isLgSize = size === 'lg'

   return (
      <View
         display="flex"
         justifyContent="space-between"
         alignItems="center"
         height={isLgSize && theme.titlebarLgHeight}
         width="100%"
         paddingLeft={paddingLeft}
         paddingRight={paddingRight}
         paddingVertical={!isLgSize && theme.tmpSpacingTop}
         borderBottom={borderStyle || `1px solid ${theme.tmpContentLineColor}`}>
         {children}
      </View>
   )
}

Titlebar.propTypes = {
   borderStyle: PropTypes.string,
   children: PropTypes.node.isRequired,
   paddingLeft: PropTypes.string,
   paddingRight: PropTypes.string,
   size: PropTypes.oneOf(['md', 'lg'])
}

Titlebar.defaultProps = {
   borderStyle: undefined,
   paddingLeft: undefined,
   paddingRight: undefined,
   size: 'md'
}

export default Titlebar
